import React, { CSSProperties } from 'react';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { useLatestChatsQuery } from '@school_ify/schoolify-repository/src/shared/types';

import useDeviceDetect from 'hooks/useDeviceDetect';
import Card from 'components/Card/Card';
import messageIcon from 'assets/icons/header/latest-chats.svg';
import { getUser } from 'redux/authentication/auth.slice';
import { useAppSelector } from 'redux/hooks';

import ChatItem from './components/ChatItem/ChatItem';

import './LatestChat.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
}

const Classes: React.FC<Props> = ({ style }) => {
  const { id: user_id } = useAppSelector(getUser);

  const { data } = useLatestChatsQuery({
    variables: { user_id },
    fetchPolicy: 'network-only',
  });
  const transformChat = chat_message => {
    const { chat, user, body, created_at } = chat_message;

    const transformedChat = {
      id: chat?.id,
      title: chat?.type === 'GROUP' ? chat.title : user?.full_name,
      name: user?.full_name,
      time: moment(created_at).format('DD.MM.YYYY, h:mm a'), // "Sunday, February 14th 2010, 3:25:50 pm"
      type: chat?.type,
      message: body,
      user_id: user.id,
    };
    return transformedChat;
  };
  const { isMobile } = useDeviceDetect();
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <div className="latest-chat-container" style={style}>
      <Card
        title={
          <>
            <img className="card-icon" src={messageIcon} alt="message icon" />
            {t('common:latest_chats')}
          </>
        }
        foldable={isMobile}
      >
        {!isMobile && (
          <Card.Header>
            <img className="card-icon" src={messageIcon} alt="message icon" />
            <h4 className="card-title">{t('common:latest_chats')}</h4>
            <div className="dropdown">
              {/* <CardDropDown>
                            {menu.map(menuItem => (
                                <div
                                    className="dropdown-element pointer"
                                    key={`${menuItem.name}-${menuItem.id}`}
                                >
                                    <ThemeCheckBox
                                        round
                                        label={menuItem.name}
                                        checked={activeFilter === menuItem.id}
                                        onChange={() => setActiveFilter(menuItem.id)}
                                    />
                                </div>
                            ))}
                        </CardDropDown> */}
            </div>
          </Card.Header>
        )}
        <Card.Body style={{ padding: '10px 24px' }}>
          {data &&
            data.chat_messages.map(chat => (
              <ChatItem content={transformChat(chat)} key={chat.id} />
            ))}
          {/* <div className="show-more">
            <Button
              onClick={() => {
                history.push('/chat');
              }}
              round
              outlined
              style={{
                backgroundColor: '#fff',
                border: '2px solid #5CD79E',
                padding: '0px 20px'
              }}
            >
              {t('common:go_to_chat')}
            </Button>
          </div> */}
          <div className="show-more flex justify-center">
            <p className="load-button" onClick={() => history.push('/chat')}>
              {t('common:go_to_chat')}
            </p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Classes;
